// extracted by mini-css-extract-plugin
export default {"Notfound":"Notfound_Notfound__A7rOO"};